<template>
  <div id="app" ondragstart="return false">
   
      <router-view />
  
  </div>
</template>

<script>
export default {
  name: "app",
  components: {},
  created() {},
};
</script>

<style>

</style>
